module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anyPayDetail_box"
  }, [_c('div', {
    staticClass: "DetailTop"
  }, [_c('div', {
    staticClass: "topL"
  }, [_vm._v("订单ID：" + _vm._s(_vm.orderInfoObj.id))]), _vm._v(" "), _c('div', {
    staticClass: "topR"
  }, [_c('span', [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "circleBox"
  }, [_vm._v(" " + _vm._s(_vm.orderInfoObj.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "restaurantList"
  }, [_c('div', {
    staticClass: "listBox"
  }, [_c('div', {
    staticClass: "blueLind"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "infoDetail clearfix"
  }, [_c('ul', [_c('li', [_c('p', [_c('label', [_vm._v("收款账号：")]), _vm._v(_vm._s(_vm.orderInfoObj.accont))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('label', [_vm._v("金额：")]), _vm._v(_vm._s(_vm.orderInfoObj.totalMoney))])]), _vm._v(" "), _c('li', [_c('p', [_c('label', [_vm._v("费用代码：")]), _vm._v(_vm._s(_vm.orderInfoObj.feeCode))]), _vm._v(" "), _c('p', [_c('label', [_vm._v("费用名称：")]), _vm._v(_vm._s(_vm.orderInfoObj.feeName))])]), _vm._v(" "), _c('li', [_c('p', [_c('label', [_vm._v("付款代码：")]), _vm._v(_vm._s(_vm.orderInfoObj.payCode))]), _vm._v(" "), _c('p', [_c('label', [_vm._v("付款方式：")]), _vm._v(_vm._s(_vm._f("payWayf")(_vm.orderInfoObj.taWay)))])]), _vm._v(" "), _c('li', [_c('p', [_c('label', [_vm._v("支付金额：")]), _vm._v(_vm._s(_vm.orderInfoObj.payMoney))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100"
  }, [_c('label', [_vm._v("支付时间：")]), _vm._v(_vm._s(_vm.orderInfoObj.payDate))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100"
  }, [_c('label', [_vm._v("订单号：")]), _vm._v(_vm._s(_vm.orderInfoObj.orderNo))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100"
  }, [_c('label', [_vm._v(_vm._s(_vm.SYS_DEVICE == "ICBC" ? "参考号" : "凭证号") + "：")]), _vm._v(_vm._s(_vm._f("fitOrderNo")(_vm.orderInfoObj.taNo)))])]), _vm._v(" "), (_vm.orderInfoObj.cancelDate) ? _c('li', [_c('p', [_c('label', [_vm._v("撤消金额：")]), _vm._v(_vm._s(_vm.orderInfoObj.cancelMoney))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfoObj.cancelDate) ? _c('li', [_c('p', [_c('label', [_vm._v("撤消人：")]), _vm._v(_vm._s(_vm.orderInfoObj.cancelUserCode))]), _vm._v(" "), _c('p', [_c('label', [_vm._v("撤消凭证：")]), _vm._v(_vm._s(_vm.orderInfoObj.remark))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfoObj.cancelDate) ? _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100"
  }, [_c('label', [_vm._v("撤消时间：")]), _vm._v(_vm._s(_vm.orderInfoObj.cancelDate))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "listBox clearBottom"
  }, [_c('div', {
    staticClass: "blueLind"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "infoDetail clearfix",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('ul', [_c('li', [_c('p', [_c('label', [_vm._v("创建人：")]), _vm._v(_vm._s(_vm.orderInfoObj.createUser))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100"
  }, [_c('label', [_vm._v("创建时间：")]), _vm._v(_vm._s(_vm.orderInfoObj.createDate))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100"
  }, [_c('label', [_vm._v("修改人：")]), _vm._v(_vm._s(_vm.orderInfoObj.modifyUser))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100"
  }, [_c('label', [_vm._v("修改时间：")]), _vm._v(_vm._s(_vm.orderInfoObj.modifyDate))])]), _vm._v(" "), _c('li', {
    staticClass: "p100"
  }, [_c('p', {
    staticClass: "p100",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('label', [_vm._v("支付数据包：")]), _vm._v(" "), (!_vm.disdetail) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.disdetail = true
      }
    }
  }, [_vm._v("[查看]")]) : _c('span', [_vm._v(_vm._s(_vm.orderInfoObj.taBody))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipCheckBox"
  }, [_c('div', {
    staticClass: "infoBo"
  }, [_c('span', [_vm._v("基本信息")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vipCheckBox"
  }, [_c('div', {
    staticClass: "infoBo"
  }, [_c('span', [_vm._v("更多信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2df8160a","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/anypayMasterList.vue
// module id = 1760
// module chunks = 107